var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb-container",class:_vm.useOffset ? 'breadcrumb-with-offset' : 'breadcrumb-without-offset'},[_c('span',{staticClass:"breadcrumb-link",on:{"click":_vm.onClick}},[_vm._t("default",function(){return [_vm._v("Tilbage")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }